import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "dayjs/locale/tr";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";
import "./services/language/i18n.ts";

createRoot(document.getElementById("root")!).render(<App />);
